<template>
  <div
    id="seleciona-aplicacao"
    v-loading="loading"
  >
    <div
      v-if="!error && type === 'select'"
      v-loading="loading"
      style="display: flex"
    >
      <el-button
        @click="selected = item.id_cliente_app; onChange(item.id_cliente_app)"
        v-for="item in aplicacoes"
        :key="item.id_cliente_app"
        :class="{ 'selected': item.id_cliente_app === selectedApp, 'botao-seleciona-aplicacao': true }"
      >
        <img :src="item.icon" class="logo-aplicacao " />
        {{ item.descricao }}
      </el-button>
    </div>
    <div v-if="!error && type === 'lista'">
      <h1>Seleciona uma Aplicação</h1>
      <p class="desc-label">Antes de processguir selecione uma aplicação para qual deseja gerenciar o conteúdo
                            acessado:</p>

      <div class="apliacoes">
        <div
          v-for="item in aplicacoes"
          :key="item.id_cliente_app"
          :class="{ 'aplicacao': true, 'selected': item.id_cliente_app === selectedApp }"
          @click="selected = item.id_cliente_app; onChange(item.id_cliente_app)"
        >
          <p><b>{{ item.descricao }}</b></p>
        </div>
      </div>
    </div>
    <div v-if="error">
      <el-alert
        show-icon
        title="Falha ao buscar aplicações disponíveis. Por favor tente novamente. Se o problema persistir contate o suporte."
        type="error"
      >
      </el-alert>
    </div>
  </div>
</template>
<script>
import api from '@/api/configuradorPublicoApi.js'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'SelecionaAplicacao',
  props: {
    type: {
      default: 'select'
    },
    defaultSelected: {
      default: null
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      selected: null,
      appSelecionado: null
    }
  },
  watch: {
    defaultSelected (value) {
      this.appSelecionado = value
    }
  },
  computed: {
    ...mapState('SelecionaAplicacao', ['aplicacoes', 'aplicacaoSelecionada']),
    selectedApp () {
      return this.appSelecionado || this.aplicacoes[0].id_cliente_app
    }
  },
  methods: {
    ...mapMutations('SelecionaAplicacao', ['SELECIONA_APLICACAO', 'SET_APLICACOES']),
    async init () {
      this.loading = true
      if (this.aplicacaoSelecionada) {
        await this.onChange(this.aplicacaoSelecionada)
        this.loading = false
        return
      }

      if (this.aplicacoes && this.appSelecionado) {
        await this.onChange(this.appSelecionado)
        this.loading = false
        return
      }

      if (this.aplicacoes && this.aplicacoes.length > 0) {
        await this.onChange(this.aplicacoes[0].id_cliente_app)

        this.loading = false
        return
      }
      await this.listaAplicacoes()
    },
    async listaAplicacoes () {
      try {
        const result = await api.listaAplicacoes()

        if (result.status === 200 && result.data && result.data.status) {
          let aplicacoes = result.data.data
          const promises = aplicacoes.map(async (item) => {
            let esquemaDeCor = await this.__handlerEsquemaDeCores(item.id_cliente_app)
            let iconData = this.iconApp(esquemaDeCor)
            return {
              ...item,
              possuiIcon: iconData.possuiIcon,
              icon: iconData.icon,
              esquema_de_cores: esquemaDeCor
            }
          })

          const aplication = await Promise.all(promises)
          await this.SET_APLICACOES(aplication)

          if (result.data.data.length > 0) {
            await this.onChange(result.data.data[0].id_cliente_app)
          } else {
            this.error = true
          }
        } else {
          this.error = true
        }
      } catch (error) {
        this.error = true
      }
      this.loading = false
    },
    async onChange (value) {
      await this.setAppSelecionado(value)
      this.$emit('aplicacaoSelecionada', value)
    },
    async setAppSelecionado (value) {
      this.appSelecionado = value
      this.selected = value
      await this.SELECIONA_APLICACAO(value)
    },
    async __loadVersoesAtivas (idConfigClienteApp) {
      const result = await api.carregaVersoesAtivas({ idConfigClienteApp })
        .then(result => {
          if (result.status === 200 && result.data && result.data.status) {
            return result.data.data
          }
        })
      return result
    },
    async __loadEsquemaDeCor (idConfigClienteApp, idVersao) {
      const esquemasCores = await api.listarEsquemaDeCores({ idConfigClienteApp, idVersao })
      if (Object.keys(esquemasCores.data.data).length === 0) { return {} }
      let esquemaCor = esquemasCores.data.data.find(item => item.default === 1)
      let idEsquemaDeCores = esquemaCor.id_config_app_esquema_cor

      const result = await api.carregarEsquemaDeCores({ idConfigClienteApp, idVersao, idEsquemaDeCores })
        .then(result => {
          if (result.status === 200 && result.data && result.data.status) {
            return result.data.data
          }
        })
      return result
    },
    async __handlerEsquemaDeCores (idConfigClienteApp) {
      const versoesAtivas = await this.__loadVersoesAtivas(idConfigClienteApp)
      let versao = versoesAtivas.producao || versoesAtivas.sandbox
      let idVersao = versao.id_config_cliente_app_versao
      const result = await this.__loadEsquemaDeCor(idConfigClienteApp, idVersao)
      return result
    },
    iconApp (esquemaDeCor) {
      let payload = {
        icon: require('@/assets/img/avatar-empresa-default.png'),
        possuiIcon: false
      }
      if (Object.keys(esquemaDeCor).length === 0) { return payload }
      let estilosImagensWeb = esquemaDeCor.estilos.find(item => item.nome_grupo === 'imagensWeb')
      if (!estilosImagensWeb) {
        return payload
      }
      let icon = estilosImagensWeb.estilos.find(item => item.chave === 'favIconWeb')
      if (!icon) {
        return payload
      }
      return {
        icon: icon.valor_atribuido,
        possuiIcon: true
      }
    }
  },
  async mounted () {
    alert('TEM QUE REMOVER ESSA BARRA DESSA TELA!!!')
    setTimeout(() => {
      this.init()
    }, 300)
  }
}
</script>
<style lang="less">
.el-button {
  &.botao-seleciona-aplicacao {
    span {
      display: flex;
      align-items: center;
      align-content: center;
    }
  }
}
</style>
<style lang="less" scoped>
.desc-label {
  display: inline-block;
  margin: 0 0 10px;
}
.botao-seleciona-aplicacao {
  display: flex;
  align-items: center;
  align-content: center;
  span {
    .logo-aplicacao {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      border-radius: 5px;
    }
  }
}

.apliacoes {
  .aplicacao {
    border: 2px solid #ccc;
    padding: 5px 15px;
    cursor: pointer;
    margin-bottom: 10px;

    &:hover {
      border-color: #333333;
    }

    &.selected {
      color: #4A30CE;
      border-color: #4A30CE;
    }
  }
}
.el-button {
  margin: 0 10px 10px 0;
  padding: 0 5px;
  height: 30px;
  border-radius: 5px;
  cursor: pointer;
  background-color: #fff;
  text-align: left;
  font: normal bold 11px/15px;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
  opacity: 1;
  border: 2px solid #ccc;
  &.selected {
    border-color: #0075EA;
  }
}
</style>
